module.exports = __webpack_public_path__ + "img/qcgyl.png";